var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.20841 8.80866C3.88496 8.80866 4.43341 8.26021 4.43341 7.58366C4.43341 6.90711 3.88496 6.35866 3.20841 6.35866C2.53187 6.35866 1.98341 6.90711 1.98341 7.58366C1.98341 8.26021 2.53187 8.80866 3.20841 8.80866ZM8.45841 4.43366C9.13496 4.43366 9.68341 3.88521 9.68341 3.20866C9.68341 2.53211 9.13496 1.98366 8.45841 1.98366C7.78187 1.98366 7.23341 2.53211 7.23341 3.20866C7.23341 3.88521 7.78187 4.43366 8.45841 4.43366ZM10.7917 12.2503C11.4683 12.2503 12.0167 11.7019 12.0167 11.0253C12.0167 10.3488 11.4683 9.80032 10.7917 9.80032C10.1152 9.80032 9.56675 10.3488 9.56675 11.0253C9.56675 11.7019 10.1152 12.2503 10.7917 12.2503ZM10.5001 3.20866C10.5001 4.33624 9.586 5.25033 8.45841 5.25033C7.33083 5.25033 6.41675 4.33624 6.41675 3.20866C6.41675 2.08108 7.33083 1.16699 8.45841 1.16699C9.586 1.16699 10.5001 2.08108 10.5001 3.20866ZM5.25008 7.58366C5.25008 8.71124 4.336 9.62533 3.20841 9.62533C2.08083 9.62533 1.16675 8.71124 1.16675 7.58366C1.16675 6.45608 2.08083 5.54199 3.20841 5.54199C4.336 5.54199 5.25008 6.45608 5.25008 7.58366ZM10.7917 13.067C11.9193 13.067 12.8334 12.1529 12.8334 11.0253C12.8334 9.89774 11.9193 8.98366 10.7917 8.98366C9.66417 8.98366 8.75008 9.89774 8.75008 11.0253C8.75008 12.1529 9.66417 13.067 10.7917 13.067Z",
    fill: "#3D3962"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.37134,
    y: 6.29883,
    width: 3.64719,
    height: 0.816667,
    transform: "rotate(-39.7434 4.37134 6.29883)",
    fill: "#3D3962"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4.93545,
    height: 0.816667,
    transform: "matrix(0.912402 0.409295 0.409295 -0.912402 4.74976 8.75)",
    fill: "#3D3962"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShare);
export default __webpack_public_path__ + "static/media/ic_share.e0b5febe133ec343d5a81ac7975a7f76.svg";
export { ForwardRef as ReactComponent };